import { MentionSearchQueryModel } from '../../../Monitor/Shared/models/mention-search-query.model';
import { SavedFilterApi } from './saved-filter-api.model';
import { SavedFilterTypeEnum } from '../enums/saved-filter.enum';
import { BaseModel } from '../../Basic/models/base.model';

export class SavedFilter extends BaseModel<SavedFilter, SavedFilterApi>{
    id: number;
    name: string;

    type: SavedFilterTypeEnum;
    query: MentionSearchQueryModel;

    favorite: boolean;
    showSimilar: boolean;

    // readonly
    createdByUserId: number;
    createdDate: Date;

    modifiedByUserId: number;
    modifiedDate: Date;

    constructor(apiModel?: SavedFilterApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: SavedFilterApi) {
        this.id = apiModel.id;
        this.name = apiModel.name;
        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = new Date(apiModel.createdDate);
        this.modifiedDate = new Date(apiModel.createdDate);
        this.modifiedByUserId = apiModel.lastModifiedByUserId;
        this.query = new MentionSearchQueryModel(apiModel.query);
        this.type = apiModel.type;
        this.favorite = apiModel.favourite;
        this.showSimilar = apiModel.showSimilar;
    }

    constructDefault() {
        this.id = null;
        this.name = '';
        this.favorite = false;
    }

    toApiModel(): SavedFilterApi {
        const apiModel: SavedFilterApi = {
            id: this.id,
            name: this.name?.trim(),
            type: this.type,
            query: this.query.getApiEntity(),
            favourite: this.favorite,
            createdDate: +this.createdDate,
            createdByUserId: this.createdByUserId,
            lastModifiedDate: +this.modifiedDate,
            lastModifiedByUserId: this.modifiedByUserId,
            showSimilar: this.showSimilar
        };
        delete apiModel.query.publicationDate;
        return apiModel;
    };

    clone(): SavedFilter {
        const clone = new SavedFilter(this.toApiModel());
        return clone;
    }

    equals(other?: SavedFilter): boolean {

        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        if (this.type !== other.type) {
            return false;
        }

        if (!this.query.equals(other.query)) {
            return false;
        }

        if (this.favorite !== other.favorite) {
            return false;
        }

        if (this.showSimilar !== other.showSimilar) {
            return false;
        }

        return true;
    };
}
